import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ProductService } from '../../shared/services/product.service';
import { SnackBarService } from '../../shared/services/snack-bar.service';
@Component({
    selector: 'pme-routes',
    templateUrl: './routes.component.html',
    styleUrls: ['./routes.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DevelopmentRoutesComponent implements OnInit {
  businessId: string;
  userId: string;

  identificationForm: UntypedFormGroup;

  submitting: boolean;
  submitted: boolean = false;

  routesErrors: any = [];

  checkoutLinks: any [];
  selfAttendanceLinks: any [];
  selfAttendanceHash: string;
  classifications: any = {};
  allRoutes: any = [];
  foundRoutes: any = [];
  searchValue: string;
  searchForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private productService: ProductService,
    private snackBarService: SnackBarService
  ) {
    this.identificationForm = this.formBuilder.group({
      businessId: ["5eb4a4acae3b6a1817475404", Validators.required],
      userId: ["5eb4a4acae3b6a1817475403", Validators.required]
    });

    this.searchForm = this.formBuilder.group({
      searchValue: ['']
    });
  }

  ngOnInit(): void {
  }

  getIdentificationErrors(): { [key: string]: any } {
    const map: { [key: string]: string} = {};
    // Validando requireds
    Object.keys(this.identificationForm.controls).forEach(key => {
      const keyName = key.toString();
      map[keyName] = this.identificationForm.controls[keyName].hasError('required') ? 'Campo obrigatório' : null;
    });

    // Validacoes específicas
    map.businessId = map.businessId || this.identificationForm.controls.businessId.getError('businessIdError');
    map.userId = map.userId || this.identificationForm.controls.userId.getError('userIdError');

    return map;
  }

  onSubmit() {
    if(this.identificationForm.valid){
      this.submitting = true;
      this.productService.getEcommerceUrls(this.businessId, this.userId).subscribe(
        (routesData: any) => {
          if(routesData){
            this.selfAttendanceHash = routesData.hash;
            if(routesData.routes){
              Object.keys(routesData.routes).forEach(classificationKey => {
                if(routesData.routes[classificationKey].length) {
                  this.classifications[classificationKey] = routesData.routes[classificationKey];

                  routesData.routes[classificationKey].forEach(route => {
                    this.allRoutes.push(route);
                  });
                }
              });

              this.classifications = this.sortRoutes(this.classifications)
            }
          }
          this.submitted = true;
          this.submitting = false;
        },
        (error) => {
          console.error(error);
          this.submitting = false;
          this.submitted = false;
        }
      )
    }
  }

  copied(event) {
    this.snackBarService.openSnackBar(event);
  }

  open(link: string) {
    const prefix = link.startsWith("http") ? "" : "http://";

    window.open(prefix + link, "_blank");
  }

  getClassificationKeys() {
    if (this.classifications) {
      return Object.keys(this.classifications);
    }
    return [];
  }

  searchRoutes() {
    let searchWords = this.searchForm.value.searchValue.split(" ");

    searchWords.forEach(word => {
      word = word.toUpperCase();
      this.foundRoutes = this.allRoutes.filter(obj => {
        if (obj.type.toUpperCase().includes(word) ||
            obj.type.toUpperCase().replace(/[\u0300-\u036f]/g, "").includes(word) ||
            obj.classification.name.toUpperCase().replace(/[\u0300-\u036f]/g, "").includes(word)) {
              return obj;
            }
      });
    });
  }

  sortRoutes(routes) {
    let sortedRoutes = {};
    let sortedKeys = Object.keys(routes).sort( (a,b) => {

    let classificationA = routes[a][0].classification.name.toUpperCase();
    let classificationB = routes[b][0].classification.name.toUpperCase();

    if (classificationA > classificationB) return 1;
    else if (classificationA < classificationB) return -1;
    else return 0;

    });

    sortedKeys.forEach(key => {
        sortedRoutes[key] = routes[key];
    });

    return sortedRoutes;
  }
}
